module.exports = __webpack_public_path__ + "static/img/success14.2ad75580.png";